import { Button, Col, Form, Input, message, Radio, Row, Select, Switch, Divider, Icon, Checkbox, Tooltip } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import { RadioChangeEvent } from 'antd/lib/radio';
import * as React from 'react';
import { Dispatch } from 'redux';
import { ORDER_PAYMENT_SET, PAYMENT_ALIPY, PAYMENT_PAYPAL } from 'src/constants/Order';
import { IAgentInfo, IAgentSetting } from 'src/entity/AgentEntity';
import { DecoctionUnitDict, IDrugStoreInfo, IProcessingTemplates, ISubDrugStore, ProcessMethod } from 'src/entity/DrugStoreEntity';
import { ILocationInfo, IAreaInfo } from 'src/entity/LocationEntity';
import { IPaymentAccount } from 'src/entity/PaymentEntity';
import { IPaymentSetting, IExpressConfig, BookkeepingPolicyDict } from 'src/entity/SettingEntity';
import { fetchLocationsIfNeeded } from 'src/redux/actions/locationCreator';
import { updateAgentInfo, updateDrugStoreInfo } from 'src/redux/actions/userCreator';
import I18N from 'src/services/I18NService';
import LocationService from 'src/services/LocationService';
import { CurrencyType, OrderPayment } from 'src/services/OrderService';
import { isArray } from 'util';
import FreightTemplateSetting from './FreightTemplateSetting';
import { freightTemplate2PageData } from './FreightTemplateSetting';
import DrugStoreService from 'src/services/DrugStoreService';
import { getUserInfo, getMethodDes } from '../../../redux/actions/userCreator';
import { EnumMedicineType } from 'src/constants/enum';
import { MallMedicineType } from 'src/services/MallService';

interface IPaymentSetFormProps extends FormComponentProps {
  isAgent: boolean;
  isDomestic: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  locations: ILocationInfo[];
  dispatch: Dispatch<any>;
}

interface IPaymentSetFormState {
  paymentSet: IPaymentSetting | undefined;
  expressConfig: IExpressConfig[];
  areaInited: boolean;
  // areaTreeData: TreeNode[];
}

class PaymentSetForm extends React.Component<IPaymentSetFormProps, IPaymentSetFormState> {
  canSubmit = true;
  state: IPaymentSetFormState = {
    paymentSet: undefined,
    expressConfig: [],
    areaInited: false,
    // areaTreeData: [],
  };

  constructor(props: IPaymentSetFormProps) {
    super(props);
  }

  async UNSAFE_componentWillMount() {
    // const { isAgent, userInfo } = this.props;
    const { isAgent } = this.props;
    // 获取地址信息
    await this.props.dispatch(fetchLocationsIfNeeded());
    this.initPaymentSetting();
    if (!isAgent) {
      // 配药中心设置页面需要初始化地区位置
      // const regions = !!userInfo ? userInfo.regions || [] : [];
      this.initArea();
      // 境内配药中心获取快递配置
      this.getExpressConfig();
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 初始化地区服务
   */
  async initArea() {
    try {
      await LocationService.initArea();
      this.setState({ areaInited: true });
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 获取快递配置信息
   */
  async getExpressConfig() {
    try {
      const res = await DrugStoreService.fetchExpressConfig();
      if (isArray(res) && res.length > 0) {
        this.setState({ expressConfig: res });
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 初始化地区服务(已废弃)
   * @param regions
   */
  // async initArea(regions: number[]) {
  //   let serveAreaList: IAreaInfo[] = [];
  //   try {
  //     await LocationService.initArea();
  //     if (!!regions.length) {
  //       // 将配药中心的区域范围设置为treeData
  //       regions.forEach((region) => {
  //         const regionItem = LocationService.areaMap.get(region);
  //         if (!!regionItem) {
  //           serveAreaList.push(regionItem);
  //         }
  //       });
  //     } else {
  //       // 配药中心的区域范围为空，显示全省
  //       serveAreaList = LocationService.getLinkageProvince();
  //     }
  //     // 处理查看详情时 treeSelect异步加载无法显示代煎配送选中的区域范围
  //     const decoctionRegions = this.handleDecoctionRegion(serveAreaList);
  //     decoctionRegions.forEach((item) => {
  //       // 去重添加
  //       const needAdd = serveAreaList.findIndex((serveAreaItem) => serveAreaItem.value === item.value) === -1;
  //       if (needAdd) {
  //         serveAreaList.push(item);
  //       }
  //     });
  //     this.setState({
  //       areaTreeData: this.transferTreeData(serveAreaList),
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  /**
   * 处理代煎配送范围默认值(已废弃)
   * 代煎配送区域id =>
   * 获取区域链 =>
   * 循环判断区域链是否在配药中心的服务范围中
   * @param decoctionAreaId: 代煎配送区域id
   */
  // private handleDecoctionRegion(serveAreaList: IAreaInfo[]): IAreaInfo[] {
  //   const { paymentSet } = this.state;
  //   const decoctionRegions = !!paymentSet ? JSON.parse(JSON.stringify(paymentSet.decoction_regions || [])) : [];
  //   const result: IAreaInfo[] = [];
  //   if (isArray(decoctionRegions)) {
  //     decoctionRegions.forEach((decoctionAreaId) => {
  //       /** 是否在代理商服务范围之内 */
  //       let isValid = true;
  //       const decoctionAreaChain = LocationService.getAreaChain(decoctionAreaId, []);
  //       const tempList: IAreaInfo[] = [];
  //       for (let i = 0, len = decoctionAreaChain.length; i < len; i++) {
  //         const item = decoctionAreaChain[i];
  //         isValid = serveAreaList.findIndex((serveArea) => serveArea.value === item.value) !== -1;
  //         tempList.push(item);
  //         // 直接上层, 将其直接下层列表添加入result
  //         const childList = LocationService.getLinkageAreaByParentId(item.value);
  //         tempList.push(...childList);
  //         if (isValid) {
  //           break;
  //         }
  //       }
  //       if (isValid) {
  //         result.push(...tempList);
  //       } else {
  //         // 清空错误的数据
  //         if (!!paymentSet && isArray(paymentSet.decoction_regions)) {
  //           const deleteIndex = paymentSet.decoction_regions.findIndex((decoctionItem) => decoctionItem === decoctionAreaId);
  //           paymentSet.decoction_regions.splice(deleteIndex, 1);
  //           this.setState({ paymentSet });
  //         }
  //         console.error('之前选择的代煎范围超出服务范围');
  //       }
  //     });
  //   }
  //   return result;
  // }

  /**
   * 将IAreaInfo[] => TreeNode[] (已废弃)
   * @param sourceData
   */
  // private transferTreeData(sourceData: IAreaInfo[]): TreeNode[] {
  //   const result: TreeNode[] = [];
  //   sourceData.forEach((item) => {
  //     result.push({
  //       id: item.value.toString(),
  //       pId: typeof item.parentVal === 'number' ? item.parentVal.toString() : undefined,
  //       title: item.text,
  //       value: item.value,
  //     });
  //   });
  //   return result;
  // }

  /**
   * treeSelect 区域异步加载(已废弃)
   */
  // onLoadAreaData = (treeNode: any) => {
  //   return new Promise((resolve) => {
  //     const { value } = treeNode.props;
  //     const areaTreeData: TreeNode[] = JSON.parse(JSON.stringify(this.state.areaTreeData));
  //     const childList = LocationService.getLinkageAreaByParentId(value);
  //     const childTreeData = this.transferTreeData(childList);
  //     childTreeData.forEach((childItem) => {
  //       const needAdd = areaTreeData.findIndex((treeItem) => treeItem.value === childItem.value) === -1;
  //       if (needAdd) {
  //         areaTreeData.push(childItem);
  //       }
  //     });
  //     this.setState({
  //       areaTreeData,
  //     });
  //     resolve();
  //   });
  // };

  /**
   * 初始化默认设置
   *
   * @memberof PaymentSetForm
   */
  initPaymentSetting() {
    const { userInfo, isDomestic } = this.props;
    if (!!userInfo) {
      let defaultPayment = userInfo.default_payment;
      if (!defaultPayment) {
        defaultPayment = isDomestic ? PAYMENT_ALIPY : PAYMENT_PAYPAL;
      }
      this.getPaymentSettingByDefault(defaultPayment);
    }
  }

  /**
   * 根据默认支付方式获取内容
   *
   * @param {string} defaultPayment
   * @memberof PaymentSetForm
   */
  getPaymentSettingByDefault(defaultPayment: string) {
    const { userInfo, isDomestic, isAgent } = this.props;
    if (!!userInfo) {
      let accountObj: IPaymentAccount | undefined;
      if (!!defaultPayment) {
        accountObj = userInfo.payment_accounts.find((p) => p.category === defaultPayment);
      }

      const setObj: IPaymentSetting = {
        currency_type: userInfo.currency,
        payment_type: !!accountObj ? accountObj.category : isDomestic ? PAYMENT_ALIPY : PAYMENT_PAYPAL,
        account_name: !!accountObj ? accountObj.account_name : undefined,
        client_id: !!accountObj ? accountObj.client_id : undefined,
        client_secret: !!accountObj ? accountObj.client_secret : undefined,
        allow_change_medicine_setting: userInfo.allow_change_medicine_setting,
        bookkeeping_policy: userInfo.bookkeeping_policy,
        // package_price: userInfo.package_price,
        // std_freight_price: userInfo.std_freight_price,
        notice: !isAgent ? (userInfo as IDrugStoreInfo).notice : undefined,
        // decoction_enabled: !isAgent ? (userInfo as IDrugStoreInfo).decoction_enabled : undefined,
        // decoction_required: !isAgent ? (userInfo as IDrugStoreInfo).decoction_required : undefined,
        // decoction_fee: !isAgent
        //   ? {
        //       fee: (userInfo as IDrugStoreInfo).decoction_price,
        //       feeUnit: (userInfo as IDrugStoreInfo).decoction_unit || 0,
        //     }
        //   : undefined,
        decoction_capacity: (userInfo as IDrugStoreInfo).decoction_capacity,
        decoction_regions: !isAgent ? (userInfo as IDrugStoreInfo).decoction_regions : undefined,
        freight_templates: freightTemplate2PageData((userInfo as IDrugStoreInfo).freight_templates),
        express_profit_recipient: !isAgent ? (userInfo as IDrugStoreInfo).express_profit_recipient : undefined,
        express_company: !isAgent ? (userInfo as IDrugStoreInfo).express_company : undefined,
        express_type: !isAgent ? (userInfo as IDrugStoreInfo).express_type : undefined,
        express_bill_template: !isAgent ? (userInfo as IDrugStoreInfo).express_bill_template : undefined,
        express_payer: !isAgent ? (userInfo as IDrugStoreInfo).express_payer : undefined,
        express_payment_type: !isAgent ? (userInfo as IDrugStoreInfo).express_payment_type : undefined,
        express_payment_account: !isAgent ? (userInfo as IDrugStoreInfo).express_payment_account : undefined,
        delivery_name: !isAgent ? (userInfo as IDrugStoreInfo).delivery_name : undefined,
        delivery_mobile: !isAgent ? (userInfo as IDrugStoreInfo).delivery_mobile : undefined,
        delivery_location: !isAgent ? (userInfo as IDrugStoreInfo).delivery_location : undefined,
        delivery_address: !isAgent ? (userInfo as IDrugStoreInfo).delivery_address : undefined,
        processing_enabled: !isAgent ? (userInfo as IDrugStoreInfo).processing_enabled : false,
        processing_required: !isAgent ? (userInfo as IDrugStoreInfo).processing_required : false,
        processing_templates: !isAgent ? (userInfo as IDrugStoreInfo).processing_templates : [],
      };
      this.setState({
        paymentSet: setObj,
      });
    }
  }

  /**
   * 切换支付方式
   *
   * @memberof PaymentSetForm
   */
  onAccountChange = (e: RadioChangeEvent) => {
    this.props.form.setFields({
      alipy_account: { errors: null },
    });
    this.props.form.setFields({
      paypal_account: { errors: null },
    });
    this.getPaymentSettingByDefault(e.target.value);
  };

  /**
   * 提交
   *
   * @memberof PaymentSetForm
   */
  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values: IPaymentSetting) => {
      if (!err) {
        if (!this.canSubmit) {
          return;
        }
        try {
          const { isAgent, userInfo } = this.props;
          const defaultPayment: ORDER_PAYMENT_SET | undefined = this.props.form.getFieldValue('payment_type');
          let paymentAccounts: IPaymentAccount[] | undefined;
          if (!!defaultPayment && !!values.account_name && !!values.client_id && !!values.client_secret) {
            paymentAccounts = [
              {
                category: defaultPayment,
                account_name: values.account_name,
                client_id: values.client_id,
                client_secret: values.client_secret,
              },
            ];
          }
          if (isAgent) {
            // 代理商
            const data: IAgentSetting = {
              currency: values.currency_type,
              allow_change_medicine_setting: values.allow_change_medicine_setting || false,
              default_payment: defaultPayment,
              payment_accounts: paymentAccounts,
            };
            await this.props.dispatch(updateAgentInfo(data));
          } else {
            const drugStore = userInfo as IDrugStoreInfo;
            if (!!drugStore) {
              const freightPrice = +(this.props.form.getFieldValue('std_freight_price') || 0);
              const packagePrice = +(this.props.form.getFieldValue('package_price') || 0);
              // 配药中心
              const data: ISubDrugStore = {
                currency: values.currency_type,
                default_payment: defaultPayment,
                payment_accounts: paymentAccounts,
                std_freight_price: freightPrice,
                package_price: packagePrice,
                notice: values.notice,
              };
              await this.props.dispatch(updateDrugStoreInfo(data, drugStore.id));

              await this.props.dispatch(getUserInfo());
            }
          }
          this.canSubmit = true;
          message.success(I18N.get('common_save_success'));
        } catch (error) {
          this.canSubmit = true;
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        }
      }
    });
  };

  getRadioOption = (): JSX.Element[] => {
    const { isDomestic } = this.props;
    const options: JSX.Element[] = [];
    for (const option of OrderPayment) {
      if ((isDomestic && option.value === PAYMENT_ALIPY) || (!isDomestic && option.value === PAYMENT_PAYPAL)) {
        if (option.is_set) {
          options.push(
            <Radio key={option.key} value={option.value}>
              {I18N.get(option.key)}
            </Radio>
          );
        }
      }
    }
    return options;
  };

  getCurrency = (): JSX.Element[] => {
    const { isDomestic } = this.props;
    const options: JSX.Element[] = [];
    for (const option of CurrencyType) {
      if (option.isDomestic === undefined) {
        options.push(
          <Select.Option key={option.key} value={option.value}>
            {I18N.get(option.key)}
          </Select.Option>
        );
      } else {
        if (option.isDomestic === isDomestic) {
          options.push(
            <Select.Option key={option.key} value={option.value}>
              {I18N.get(option.key)}
            </Select.Option>
          );
        }
      }
    }
    return options;
  };

  /**
   * 检测代煎费用控件(已废弃)
   *
   * @memberof PaymentSetForm
   */
  // checkDecoctionFee = (rule: any, value: IDecoctionFeeData, callback: any) => {
  //   try {
  //     if (value.fee !== undefined && value.fee >= 0 && value.feeUnit !== undefined) {
  //       return callback();
  //     }
  //     callback(`${I18N.get('common_input')}${I18N.get('setting_decoction_fee')}`);
  //   } catch (err) {
  //     callback(err);
  //   }
  // };

  /**
   * 检测费用模板控件(已废弃)
   *
   * @memberof PaymentSetForm
   */
  // checkFeeTemplate = (rule: any, value: IFreightTemplateData[], callback: any) => {
  //   try {
  //     if (value.length === 0) {
  //       return callback();
  //     }

  //     const errSet = new Set<string>();
  //     const locationSet = new Set<number>();
  //     for (const data of value || []) {
  //       for (const locationId of data.locations || []) {
  //         if (locationSet.has(locationId)) {
  //           errSet.add(`${I18N.get('err_fee_template_same_area')}`);
  //         }
  //         locationSet.add(locationId);
  //       }
  //     }

  //     if (locationSet.size === this.props.locations.length && errSet.size === 0) {
  //       return callback();
  //     }

  //     if (errSet.size > 0) {
  //       return callback(`${Array.from(errSet).join(', ')}`);
  //     }

  //     callback(`${I18N.get('err_fee_template_full_area')}`);
  //   } catch (err) {
  //     callback(err);
  //   }
  // };

  /**
   * 获取代煎费描述
   */
  // getDecoctionFeeDesc(paymentSet: IPaymentSetting | undefined): string {
  //   let result = '';
  //   if (!!paymentSet && !!paymentSet.decoction_fee) {
  //     const { fee, feeUnit } = paymentSet.decoction_fee;
  //     if (!!fee) {
  //       let feeUnitDesc = '';
  //       switch (feeUnit) {
  //         case 0:
  //           feeUnitDesc = I18N.get('common_unit_fu');
  //           break;
  //         case 1:
  //           feeUnitDesc = I18N.get('common_unit_ji');
  //           break;
  //         case 2:
  //           feeUnitDesc = I18N.get('common_unit_prescription');
  //           break;
  //       }
  //       if (!!feeUnitDesc) {
  //         result = `${fee} ${I18N.get('common_unit_yuan')} / ${feeUnitDesc}`;
  //       }
  //     }
  //   }
  //   return result;
  // }


  /**
   * 获取加工服务的描述
   */
  getProcessingServiceDesc(paymentSet: IPaymentSetting | undefined): string[] {
    const result: string[] = [];
    if (!!paymentSet && !!paymentSet.processing_templates) {
      // 去除自煎加工方式
      paymentSet.processing_templates.filter(item => {
        return item.method !== ProcessMethod.SelfDecoction
      }).map((item, index) => {
        result.push(`${index + 1} ${this.getTemplateDesc(item, paymentSet.decoction_capacity)} \n`);
      })
    }
    return result;
  }

  /**
   * 获取加工方式描述
   * @param template 
   * @param capacity 
   */
  getTemplateDesc(template: IProcessingTemplates, capacity: number | undefined): string {
    const isDefault = !!template.is_default ? '（饮片默认的加工方式）' : '';
    const dosageForms = this.getApplicativeDosageForms(template.applicative_dosage_forms);
    const styleDesc = ' style="white-space: pre-wrap;line-height: 24px;padding-left: 24px; font-size:12px"';
    let result = getMethodDes(template.method) + isDefault + `<div${styleDesc}>${dosageForms}</div>`;
    result += `<div${styleDesc}>加工费：${template.price}${I18N.get('common_unit_yuan')}${this.getUnitDesc(template.price_unit)}；</div>`;
    if (!!template.package_price) {
      result += `<div${styleDesc}>包装费：${template.package_price}${I18N.get('common_unit_yuan')}${this.getUnitDesc(template.package_price_unit)}；</div>`;
    }
    if (template.method === ProcessMethod.HerbalDecoction) {
      const capacityNum = capacity || 0;
      result += `<div${styleDesc}>${I18N.get('setting_decoction_capacity')}：${capacityNum}ml；</div>`;
    }
    return result;
  }

  /** 获取当前使用剂型对应的文字 */
  getApplicativeDosageForms(data: EnumMedicineType[]): string {
    const list: string[] = [];
    if (data.length > 0) {
      data.forEach(item => {
        const find = MallMedicineType.find(type => type.value === item);
        if (!!find) {
          list.push(find.name || '');
        }
      })
    }
    if (list.length > 0) {
      return `适用剂型：${list.join('、')}；`;
    }
    return '';
  }

  /**
   * 匹配加工费用单位
   */
  getUnitDesc(unit: DecoctionUnitDict): string {
    let name = ' / ';
    switch (unit) {
      case DecoctionUnitDict.Times:
        name += I18N.get('common_unit_fu');
        break;
      case DecoctionUnitDict.Dose:
        name += I18N.get('common_unit_ji');
        break;
      case DecoctionUnitDict.Prescription:
        name += I18N.get('common_unit_prescription');
        break;
      case DecoctionUnitDict.Order:
        name += I18N.get('common_unit_order');
        break;
      case DecoctionUnitDict.Kilo:
        name += I18N.get('common_unit_kilo');
        break;
      case DecoctionUnitDict.HundredGram:
        name += '每百克';
        break;
      default:
        break;
    }
    return name;
  }

  render() {
    const { isAgent, isDomestic, userInfo, locations } = this.props;
    // const { paymentSet, areaTreeData } = this.state;
    const { paymentSet, expressConfig, areaInited } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };

    const formItemLayoutSmall: FormItemProps = {
      labelCol: { span: 4 },
      wrapperCol: { span: 6 },
    };

    /** 是否取药方式支持自取 */
    let isUsedSelfMention = false;
    /** 是否取药方式支持快递 */
    let isUsedExpress = false;
    /** 自取地址 */
    let selfMentionAddress = '';
    /** 取药方式 */
    const takeMedicineMethod: string[] = [];
    if (!isAgent && !!userInfo) {
      isUsedSelfMention = (userInfo as IDrugStoreInfo).used_self_mention;
      isUsedExpress = (userInfo as IDrugStoreInfo).used_express;
      const { self_mention_location, self_mention_address } = userInfo as IDrugStoreInfo;
      let locationDesc = '';
      if (self_mention_location) {
        const areaChain: IAreaInfo[] = [];
        LocationService.getAreaChain(Number(self_mention_location), areaChain);
        locationDesc = areaChain.map(item => LocationService.getLinkageAreaName(item.value)).join(' ');
        selfMentionAddress += locationDesc;
      }
      if (isUsedSelfMention) {
        takeMedicineMethod.push(I18N.get('setting_self_collection'));
      }
      if (isUsedExpress) {
        takeMedicineMethod.push(I18N.get('setting_express_delivery'));
      }
      if (self_mention_address) {
        selfMentionAddress += ' ' + self_mention_address
      }
    }

    /** 是否允许医生记账描述 */
    let allowedBookkeepingDesc = '';
    if (!!paymentSet && paymentSet.bookkeeping_policy) {
      switch (paymentSet.bookkeeping_policy) {
        case BookkeepingPolicyDict.Forbid:
          allowedBookkeepingDesc = '不允许';
          break;
        case BookkeepingPolicyDict.All:
          allowedBookkeepingDesc = '全部允许';
          break;
        case BookkeepingPolicyDict.Part:
          allowedBookkeepingDesc = '限部分机构医生';
          break;
        default:
          allowedBookkeepingDesc = '不允许';
      }
    }
    /** 配药中心服务范围描述 */
    const regions = !!userInfo ? userInfo.regions || [] : [];
    const regionsDesc = areaInited ? regions.map((region) => LocationService.getLinkageAreaName(region)).join(', ') || I18N.get('setting_serve_country') : '';

    /** 是否开启加工服务 */
    const processingEnabled = !!paymentSet && paymentSet.processing_enabled ? I18N.get('common_yes') : I18N.get('common_no');
    /** 必选加工服务 */
    const processingRequired = !!paymentSet && paymentSet.processing_required ? I18N.get('common_yes') : I18N.get('common_no');
    /** 加工服务 */
    const processingTemplates = (!!paymentSet && paymentSet.processing_templates) || [];
    /** 加工服务描述 */
    const processingMethodDesc = this.getProcessingServiceDesc(paymentSet);
    const hasDecoction = processingTemplates.find(item => item.method === ProcessMethod.HerbalDecoction);
    /** 开启草药代煎服务描述 废弃 */
    // const decoctionEnabledDesc = !!paymentSet && paymentSet.decoction_enabled ? I18N.get('common_yes') : I18N.get('common_no');
    /** 代煎是否为必选描述 废弃 */
    // const decoctionRequiredDesc = !!paymentSet && paymentSet.decoction_required ? I18N.get('common_yes') : I18N.get('common_no');
    /** 代煎费用描述 废弃 */
    // const decoctionFeeDesc = this.getDecoctionFeeDesc(paymentSet);
    // const decoctionCapacityDesc = !!paymentSet && paymentSet.decoction_capacity ?
    //   `${paymentSet.decoction_capacity} ml` : '';
    /** 代煎范围描述 */
    let decoctionRegions = null;
    if (!!paymentSet && Array.isArray(paymentSet.decoction_regions) && paymentSet.decoction_regions.length > 0) {
      decoctionRegions = paymentSet.decoction_regions;
    }
    const decoctionRegionsDesc = !!decoctionRegions && areaInited ?
      decoctionRegions.map((region) => LocationService.getLinkageAreaName(region)).join(', ') : '';

    const matchedExpress = expressConfig.find(item => item.code === (paymentSet && paymentSet.express_company));
    /** 快递公司描述 */
    let expressCompanyDesc = '';
    /** 业务类型描述 */
    let expressTypeDesc = '';
    /** 面单模板描述 */
    let billTemplateDesc = '';
    /** 运费支付方-支付方式描述 */
    let expressPayerDesc = '';
    /** 月结账号描述 */
    let expressAccountDesc = '';
    if (matchedExpress && paymentSet) {
      expressCompanyDesc = matchedExpress.name;
      const matchedType = matchedExpress.express_types.find(item => item.value === paymentSet.express_type);
      expressTypeDesc = matchedType ? matchedType.name : '';
      const matchedBill = matchedExpress.express_bill_templates.find(item => item.value === paymentSet.express_bill_template);
      billTemplateDesc = matchedBill ? matchedBill.name : '';
      if (paymentSet.express_payer === 'macrocura') {
        expressPayerDesc = I18N.get('setting_express_payer_macrocura');
      } else if (paymentSet.express_payer === 'seller') {
        expressAccountDesc = paymentSet.express_payment_account || '';
        expressPayerDesc = `${I18N.get('nav_drugStore')}`;
        let paymentTypeDesc = '';
        if (paymentSet.express_payment_type === 'PAYG') {
          paymentTypeDesc = I18N.get('setting_express_pay_payg');
        } else if (paymentSet.express_payment_type === 'MON') {
          paymentTypeDesc = I18N.get('setting_express_pay_mon');
        }
        if (paymentTypeDesc) {
          expressPayerDesc = `${expressPayerDesc} - ${paymentTypeDesc}`
        }
      }
    }

    /** 发货信息 */
    let deliveryDesc = '';
    if (paymentSet) {
      const { delivery_name, delivery_mobile, delivery_location, delivery_address } = paymentSet;
      if (areaInited && delivery_name && delivery_mobile && delivery_location && delivery_address) {
        const areaChain: IAreaInfo[] = [];
        LocationService.getAreaChain(Number(delivery_location), areaChain);
        // [区市省] => [省市区]
        areaChain.reverse();
        const locationDesc = areaChain.map(item => LocationService.getLinkageAreaName(item.value)).join(' ');
        deliveryDesc = `${delivery_name} ${delivery_mobile} ${locationDesc} ${delivery_address}`;
      }
    }



    // 代煎范围 treeSelect 控件属性
    // const decoctionRegionsProps = {
    //   treeData: areaTreeData,
    //   treeDataSimpleMode: true,
    //   treeCheckable: true,
    //   allowClear: true,
    //   showCheckedStrategy: TreeSelect.SHOW_PARENT,
    //   loadData: this.onLoadAreaData,
    //   searchPlaceholder: `${I18N.get('common_choose')}${I18N.get('setting_decoction_regions')}`,
    //   style: {
    //     width: '100%',
    //   },
    //   dropdownStyle: { maxHeight: 400, overflow: 'auto' },
    // };

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          {/* 允许医生修改药材设置 */}
          {isAgent && (
            <Form.Item label={I18N.get('common_change_medicine_setting')} {...formItemLayoutSmall} key={'allow_change_medicine_setting'}>
              {getFieldDecorator(`allow_change_medicine_setting`, {
                rules: [
                  {
                    required: false,
                  },
                ],
                valuePropName: 'checked',
                initialValue: !!paymentSet ? paymentSet.allow_change_medicine_setting : true,
              })(
                <Switch
                  // defaultChecked={!!paymentSet && !!paymentSet.allow_change_medicine_setting}
                  disabled={!isAgent}
                  checkedChildren={I18N.get('common_yes')}
                  unCheckedChildren={I18N.get('common_no')}
                />
              )}
            </Form.Item>
          )}
          {/* 是否允许医生记账 */}
          {!isAgent && (
            <Form.Item label={I18N.get('drug_store_bookkeeping')} {...formItemLayoutSmall} key={'allowedBookkeepingDesc'}>
              <span className="ant-form-text">
                {allowedBookkeepingDesc}
              </span>
              {/* {getFieldDecorator(`bookkeeping_policy`, {
                rules: [
                  {
                    required: false,
                  },
                ],
                valuePropName: 'checked',
                initialValue: !!paymentSet ? paymentSet.bookkeeping_policy : true,
              })(
                <Switch
                  // defaultChecked={!!paymentSet && !!paymentSet.bookkeeping_policy}
                  checkedChildren={I18N.get('common_yes')}
                  unCheckedChildren={I18N.get('common_no')}
                />
              )} */}
            </Form.Item>
          )}
          {/* 货币种类 */}
          {!(isDomestic && isAgent) && (
            <Form.Item label={I18N.get('common_currency_type')} {...formItemLayoutSmall} key={'currency_type'}>
              {getFieldDecorator(`currency_type`, {
                rules: [
                  {
                    required: false,
                    message: `{${I18N.get('common_choose')}${I18N.get('common_currency_type')}}`,
                  },
                ],
                initialValue: !!paymentSet ? paymentSet.currency_type : undefined,
              })(<Select placeholder={`${I18N.get('common_choose')}${I18N.get('common_currency_type')}`}>{this.getCurrency()}</Select>)}
            </Form.Item>
          )}
          {/* 海外用户 */}
          {!isDomestic && (
            <React.Fragment>
              {/* 收款账号 */}
              <Form.Item label={I18N.get('common_shroff_account')} {...formItemLayoutSmall} key={'payment_type'}>
                {getFieldDecorator(`payment_type`, {
                  rules: [
                    {
                      required: false,
                      message: `{${I18N.get('common_choose')}${I18N.get('common_shroff_account')}}`,
                    },
                  ],
                  initialValue: !!paymentSet ? paymentSet.payment_type : undefined,
                })(<Radio.Group onChange={this.onAccountChange}>{this.getRadioOption()}</Radio.Group>)}
              </Form.Item>
              {/* 支付宝 */}
              {getFieldValue('payment_type') === PAYMENT_ALIPY && (
                <Form.Item label={I18N.get('common_alipy')} {...formItemLayoutSmall} key={'account_name'}>
                  {getFieldDecorator(`account_name`, {
                    rules: [
                      {
                        required: false,
                        message: `{${I18N.get('common_input')}${I18N.get('common_alipy')}}`,
                      },
                    ],
                    initialValue: !!paymentSet ? paymentSet.account_name : undefined,
                  })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('common_alipy')}`} />)}
                </Form.Item>
              )}
              {/* Paypal */}
              {getFieldValue('payment_type') === PAYMENT_PAYPAL && (
                <Form.Item label={I18N.get('common_paypal')} {...formItemLayoutSmall} key={'account_name'}>
                  {getFieldDecorator(`account_name`, {
                    rules: [
                      {
                        required: false,
                        message: `{${I18N.get('common_input')}${I18N.get('common_paypal')}}`,
                      },
                    ],
                    initialValue: !!paymentSet ? paymentSet.account_name : undefined,
                  })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('common_paypal')}`} />)}
                </Form.Item>
              )}
              {/* client id */}
              {getFieldValue('payment_type') === PAYMENT_PAYPAL && (
                <Form.Item label="client id" {...formItemLayoutSmall} key={'client_id'}>
                  {getFieldDecorator(`client_id`, {
                    rules: [
                      {
                        required: false,
                        message: `{${I18N.get('common_input')} client id}`,
                      },
                    ],
                    initialValue: !!paymentSet ? paymentSet.client_id : undefined,
                  })(<Input placeholder={`${I18N.get('common_input')} client id`} />)}
                </Form.Item>
              )}
              {/* client secret */}
              {getFieldValue('payment_type') === PAYMENT_PAYPAL && (
                <Form.Item label="client secret" {...formItemLayoutSmall} key={'client_secret'}>
                  {getFieldDecorator(`client_secret`, {
                    rules: [
                      {
                        required: false,
                        message: `{${I18N.get('common_input')} client secret}`,
                      },
                    ],
                    initialValue: !!paymentSet ? paymentSet.client_secret : undefined,
                  })(<Input placeholder={`${I18N.get('common_input')} client secret`} />)}
                </Form.Item>
              )}
            </React.Fragment>
          )}
          {/* 配药中心 */}
          {!isAgent && (
            <React.Fragment>
              <Divider dashed={true} />
              {/* 服务区域 */}
              <Form.Item label={I18N.get('setting_serve_regions')} {...formItemLayout} key={'regionsDesc'}>
                <span className="ant-form-text">{regionsDesc}</span>
              </Form.Item>
              {isUsedSelfMention && (
                <React.Fragment>
                  {/* 取药方式 */}
                  <Form.Item label={I18N.get('setting_take_medicine_method')} {...formItemLayout} key={'takeMedicineMethod'}>
                    <span className="ant-form-text">{takeMedicineMethod.join('、')}</span>
                  </Form.Item>
                  {/* 自取地址 */}
                  <Form.Item label={I18N.get('setting_self_mention_address')} {...formItemLayout} key={'selfMentionAddress'}>
                    <span className="ant-form-text">{selfMentionAddress}</span>
                  </Form.Item>
                </React.Fragment>
              )

              }
              {/* 境内配药中心 */}
              {isDomestic && (
                <React.Fragment>
                  {/* 是否开启代加工服务 */}
                  <Form.Item label={I18N.get('setting_processing_enabled')} {...formItemLayoutSmall} key={'processingEnabled'}>
                    <span className="ant-form-text">
                      {processingEnabled}
                    </span>
                    {/* {getFieldDecorator(`decoction_required`, {
                        valuePropName: 'checked',
                        initialValue: !!paymentSet ? paymentSet.decoction_required : false,
                      })(<Switch disabled={true} checkedChildren={I18N.get('common_yes')} unCheckedChildren={I18N.get('common_no')} />)} */}
                  </Form.Item>
                  {/* 必选代价加工服务 */}
                  <Form.Item label={I18N.get('setting_processing_required')} {...formItemLayoutSmall} key={'processingRequired'}>
                    <span className="ant-form-text">
                      {processingRequired}
                    </span>
                    {/* {getFieldDecorator(`decoction_enabled`, {
                      valuePropName: 'checked',
                      initialValue: !!paymentSet ? paymentSet.decoction_enabled : false,
                    })(<Switch disabled={true} checkedChildren={I18N.get('common_yes')} unCheckedChildren={I18N.get('common_no')} />)} */}
                  </Form.Item>

                  {/* 加工服务开启 => 显示 [加工方式] */}
                  {!!paymentSet && paymentSet.processing_enabled && (
                    <React.Fragment>

                      {/* 加工费用 */}
                      <Form.Item label={I18N.get('setting_processing_service')} {...formItemLayout} key={'processingMethodDesc'}>
                        <span className="ant-form-text">
                          {processingMethodDesc.map((method, index) => {
                            return <div key={index} dangerouslySetInnerHTML={{ __html: method }} />;
                          })}
                        </span>
                        {/* {getFieldDecorator(`decoction_fee`, {
                          rules: [{ required: true }, { validator: this.checkDecoctionFee }],
                          initialValue: !!paymentSet ? paymentSet.decoction_fee : undefined,
                        })(<DecoctionFeeSetting key={uuid.v4()} />)} */}
                      </Form.Item>
                      {/* 代煎容量 */}
                      {/* <Form.Item label={I18N.get('setting_decoction_capacity')} {...formItemLayoutSmall}>
                        <span className="ant-form-text">
                          {decoctionCapacityDesc}
                        </span>
                        {getFieldDecorator(`decoction_capacity`, {
                          initialValue: !!paymentSet ? paymentSet.decoction_capacity : null,
                          rules: [
                            {
                              required: true,
                              message: `${I18N.get('common_input')}${I18N.get('setting_decoction_capacity_placeholder')}`,
                            },
                          ],
                        })(
                          <InputNumber
                            min={1}
                            step={10}
                            precision={0}
                            style={{ marginRight: '4px', width: '80%' }}
                            placeholder={`${I18N.get('common_input')}${I18N.get('setting_decoction_capacity_placeholder')}`}
                          />
                        )}
                        <Tooltip placement="right" title={`${I18N.get('setting_decoction_capacity_tips')}`}>
                          <span style={{ marginRight: '8px' }}>ml</span>
                          <Icon type="question-circle" />
                        </Tooltip>
                      </Form.Item> */}
                      {/* 判断是否含有代煎方式 => 显示/隐藏 代煎配送范围 */}
                      {/* 代煎配送范围 */}
                      {
                        !!hasDecoction && (
                          <Form.Item label={I18N.get('setting_decoction_regions')} {...formItemLayout} key={'decoctionRegionsDesc'}>
                            <span className="ant-form-text">
                              {decoctionRegionsDesc}
                            </span>
                            {/* {getFieldDecorator(`decoction_regions`, {
                          initialValue: decoctionRegions,
                          rules: [
                            {
                              required: true,
                              message: `${I18N.get('common_choose')}${I18N.get('setting_decoction_regions')}`,
                            },
                          ],
                        })(<TreeSelect {...decoctionRegionsProps} />)} */}
                          </Form.Item>
                        )
                      }

                    </React.Fragment>
                  )}
                  <Divider dashed={true} />
                  {/* 快递公司 */}
                  <Form.Item label={I18N.get('setting_express_name')} {...formItemLayout} key={'expressCompanyDesc'}>
                    <span className="ant-form-text">{expressCompanyDesc}</span>
                  </Form.Item>
                  {/* 业务类型 */}
                  <Form.Item label={I18N.get('setting_express_type')} {...formItemLayout} key={'expressTypeDesc'}>
                    <span className="ant-form-text">{expressTypeDesc}</span>
                  </Form.Item>
                  {/* 面单模板 */}
                  <Form.Item label={I18N.get('setting_express_bill')} {...formItemLayout} key={'billTemplateDesc'}>
                    <span className="ant-form-text">{billTemplateDesc}</span>
                  </Form.Item>
                  {/* 运费支付方 */}
                  <Form.Item label={I18N.get('setting_express_payer')} {...formItemLayout} key={'expressPayerDesc'}>
                    <span className="ant-form-text">{expressPayerDesc}</span>
                  </Form.Item>
                  {/* 月结账号(脉景不显示) */}
                  {!!expressAccountDesc && (
                    <Form.Item label={I18N.get('setting_express_account')} {...formItemLayout} key={'expressAccountDesc'}>
                      <span className="ant-form-text">{expressAccountDesc}</span>
                    </Form.Item>
                  )}
                  {/* 运费模板设置信息 */}
                  <Form.Item label={I18N.get('setting_fee_template')} {...formItemLayout} key={'freight_templates'}>
                    {/* {getFieldDecorator(`freight_templates`, {
                      rules: [
                        {
                          required: true,
                          message: `${I18N.get('common_setting')}${I18N.get('setting_fee_template')}`,
                        },
                        { validator: this.checkFeeTemplate },
                      ],
                      initialValue: !!paymentSet ? paymentSet.freight_templates : [],
                    })(<FreightTemplateSetting locations={locations || []} />)} */}
                  </Form.Item>
                  {
                    paymentSet && paymentSet.freight_templates.map((freight_template, index) => (
                      <Form.Item label='模板名称' {...formItemLayout} key={`freight_template${index}`}>
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>{freight_template.template_name}</div>
                            <div> <Tooltip placement="top" title='药库没有设置运费模板时，默认使用的运费模板'>
                              <Checkbox checked={freight_template.is_default} disabled={true}>设为默认<Icon type="info-circle" /></Checkbox></Tooltip>
                            </div>
                          </div>
                          <div>适用药库有：{freight_template.medicine_group_name}</div>
                          <FreightTemplateSetting
                            isDetail={true}
                            value={freight_template.freight_template_content || []}
                            locations={locations || []}
                          />
                        </div>
                      </Form.Item>
                    ))
                  }
                  <Divider dashed={true} />
                  {/* 发货信息 */}
                  <Form.Item label={I18N.get('setting_delivery_info')} {...formItemLayout} key={'deliveryDesc'}>
                    <span className="ant-form-text">{deliveryDesc}</span>
                  </Form.Item>
                  <Divider dashed={true} />
                </React.Fragment>
              )}

              {/* 海外配药中心-订单运费设置 */}
              {!isDomestic && (
                <React.Fragment>
                  <Form.Item label="订单运费设置" {...formItemLayout} key={'std_freight_price_title'}>
                    <span className="ant-form-text">&nbsp;</span>
                  </Form.Item>
                  <Form.Item label={'运费价格'} {...formItemLayout} key={'std_freight_price'}>
                    <Row gutter={8}>
                      <Col span={18}>
                        {getFieldDecorator(`std_freight_price`, {
                          rules: [
                            {
                              required: true,
                            },
                          ],
                          initialValue: !!paymentSet ? paymentSet.std_freight_price : 0,
                        })(<Input placeholder={`请输入默认运费`} />)}
                      </Col>
                      <Col span={6}>
                        <span>元</span>
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item label={'包邮价格'} {...formItemLayout} key={'package_price'}>
                    <Row gutter={8}>
                      <Col span={18}>
                        {getFieldDecorator(`package_price`, {
                          rules: [
                            {
                              required: true,
                            },
                          ],
                          initialValue: !!paymentSet ? paymentSet.package_price : 0,
                        })(<Input placeholder={`请输入包邮价格`} />)}
                      </Col>
                      <Col span={6}>
                        <span>元</span>
                      </Col>
                    </Row>
                  </Form.Item>
                  <Divider dashed={true} />
                </React.Fragment>
              )}

              {/* 配药中心公告设置 */}
              <Form.Item label={I18N.get('setting_announcement')} {...formItemLayout} key={'notice'}>
                {getFieldDecorator(`notice`, {
                  rules: [
                    {
                      max: 200,
                      message: I18N.get('setting_announcement_error'),
                    },
                  ],
                  initialValue: !!paymentSet ? paymentSet.notice : '',
                })(<TextArea style={{ minHeight: 100 }} placeholder={`${I18N.get('common_input')}${I18N.get('setting_announcement')}`} />)}
              </Form.Item>
            </React.Fragment>
          )}

          <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
            <Button type="primary" htmlType="submit">
              {I18N.get('common_save')}
            </Button>
          </Form.Item>
        </Form>
      </div >
    );
  }
}

const PaymentSetComponent = Form.create<IPaymentSetFormProps>()(PaymentSetForm);
export default PaymentSetComponent;



// WEBPACK FOOTER //
// ./src/components/views/Setting/PaymentSetPage.tsx